import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import axios from "axios";
import "./Navbar.css";

import eventLogo from "../Assets/logos/logo-rmbg.png";
import collaboratorLogo from "../Assets/logos/atletasso-rmbg.png";

const API_URL = process.env.REACT_APP_BACKEND_API_URL;

// 🔥 PUT YOUR GOOGLE FORM LINK HERE
const AMBASSADOR_FORM_URL = "https://forms.gle/KRFBXY215F9Vmqp76";

const Navbar = () => {
  const [eventStart, setEventStart] = useState(null);
  const [eventEndMidnight, setEventEndMidnight] = useState(null);
  const [loadingEdition, setLoadingEdition] = useState(true);
  const [displayStatus, setDisplayStatus] = useState("loading");

  const scrollToRegistration = () => {
    const section = document.getElementById("registration-section");
    if (section) {
      const yOffset = -90;
      const y =
        section.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  // ✅ OPEN EXTERNAL GOOGLE FORM SAFELY
  const openAmbassadorForm = () => {
    if (AMBASSADOR_FORM_URL) {
      window.open(AMBASSADOR_FORM_URL, "_blank", "noopener,noreferrer");
    }
  };

  useEffect(() => {
    const fetchCurrentEdition = async () => {
      setLoadingEdition(true);

      try {
        const res = await axios.get(
          `${API_URL}/ripplerun-editions/current`
        );

        const endDateFromAPI = res.data.endDate;
        const dateOnly = endDateFromAPI.split("T")[0];

        const startUTC = new Date(`${dateOnly}T06:00:00Z`);

        const nextDay = new Date(`${dateOnly}T00:00:00Z`);
        nextDay.setUTCDate(nextDay.getUTCDate() + 1);

        setEventStart(startUTC);
        setEventEndMidnight(nextDay);
      } catch (error) {
        console.error(error);
        setDisplayStatus("comingSoon");
      } finally {
        setLoadingEdition(false);
      }
    };

    fetchCurrentEdition();
  }, []);

  useEffect(() => {
    if (!eventStart || !eventEndMidnight) return;

    const update = () => {
      const now = new Date();

      if (now < eventStart) {
        setDisplayStatus("countdown");
      } else if (now >= eventStart && now < eventEndMidnight) {
        setDisplayStatus("live");
      } else {
        setDisplayStatus("comingSoon");
      }
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [eventStart, eventEndMidnight]);

  const renderer = ({ days, hours, minutes, seconds }) => (
    <div className="navbar-countdown-wrapper">
      <div className="navbar-countdown">
        <div className="navbar-time-box">
          <span>{days}</span>
          <p>Days</p>
        </div>

        <div className="navbar-time-box">
          <span>{hours}</span>
          <p>Hrs</p>
        </div>

        <div className="navbar-time-box">
          <span>{minutes}</span>
          <p>Min</p>
        </div>

        <div className="navbar-time-box">
          <span>{seconds}</span>
          <p>Sec</p>
        </div>
      </div>

      <button
        className="navbar-register-btn"
        onClick={scrollToRegistration}
      >
        Register
      </button>
    </div>
  );

  const fallback = (
    <div className="navbar-countdown-wrapper">
      <div className="navbar-countdown">
        <div className="navbar-time-box">
          <span>0</span>
          <p>Days</p>
        </div>

        <div className="navbar-time-box">
          <span>0</span>
          <p>Hrs</p>
        </div>

        <div className="navbar-time-box">
          <span>0</span>
          <p>Min</p>
        </div>

        <div className="navbar-time-box">
          <span>0</span>
          <p>Sec</p>
        </div>
      </div>

      <button
        className="navbar-register-btn"
        onClick={scrollToRegistration}
      >
        Register
      </button>
    </div>
  );

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="nav-left">
          <img src={eventLogo} alt="logo" />
        </div>

        <div className="nav-center">
          {loadingEdition && fallback}

          {!loadingEdition && displayStatus === "countdown" && (
            <>
              <h3 className="navbar-countdown-title">
                THE COUNTDOWN BEGINS
              </h3>

              <Countdown
                date={eventStart}
                renderer={renderer}
              />
            </>
          )}

          {!loadingEdition && displayStatus === "live" && (
            <div className="navbar-live">
              <h2>🏃 TODAY IS THE DAY</h2>
              <p>The Marathon has started</p>
            </div>
          )}

          {!loadingEdition && displayStatus === "comingSoon" && (
            <div className="coming-wrapper">
              <button
                className="navbar-ambassador-btn"
                onClick={openAmbassadorForm}
                type="button"
              >
                Become Ripple Run Ambassador
              </button>
            </div>
          )}
        </div>

        <div className="nav-right">
          <img src={collaboratorLogo} alt="logo" />
        </div>
      </div>
    </header>
  );
};

export default Navbar;